const menuEl = document.getElementById('nav');
const mobileMenuButtonEl = document.getElementById('navbutton');
const menuItemEls = menuEl.querySelectorAll('.navng__item');

let isMobile = () => window.innerWidth < 993;
window.addEventListener('resize', isMobile);

mobileMenuButtonEl.addEventListener('click', e => {
	e.preventDefault();

	const isMenuOpen = menuEl.getAttribute('data-is-open') === 'true';

	menuEl.setAttribute('data-is-open', !isMenuOpen);
	mobileMenuButtonEl.setAttribute('data-is-menu-open', !isMenuOpen);
});

menuItemEls.forEach(menuItemEl => {
	const submenuEl = menuItemEl.querySelector('ul');
	if (submenuEl) {
		const submenuOpenButton = menuItemEl.querySelector('button');
		const submenuBackButton = submenuEl.querySelector('button'); // This element is mobile-only

		// Mobile
		submenuOpenButton.addEventListener('click', e => {
			if (!isMobile()) return;
			e.preventDefault();
			toggleMobileSubmenu(menuItemEl);
		});

		submenuBackButton.addEventListener('click', e => {
			if (!isMobile()) return;
			e.preventDefault();
			toggleMobileSubmenu(menuItemEl);
		});

		// Desktop
		let debounceTimer;
		submenuOpenButton.addEventListener('mouseenter', () => {
			if (isMobile()) return;
			debounceTimer = setTimeout(() => {
				toggleDesktopSubmenu(menuItemEl, true);
			}, 125);
		});

		submenuOpenButton.addEventListener('mouseleave', () => {
			if (isMobile()) return;
			clearTimeout(debounceTimer);
		});

		submenuEl.addEventListener('mouseleave', () => {
			if (isMobile()) return;
			clearTimeout(debounceTimer);
			toggleDesktopSubmenu(menuItemEl, false);
		});

		document.getElementById('announcementBar').addEventListener('mouseenter', () => {
			if (isMobile()) return;
			clearTimeout(debounceTimer);
			toggleDesktopSubmenu(menuItemEl, false);
		});
	} else {
		// Desktop: We're hovering over a plain menu link; close any open submenu (if applicable).
		menuItemEl.addEventListener('mouseenter', () => {
			if (isMobile()) return;
			toggleDesktopSubmenu(null, false);
		});
	}
});

const toggleMobileSubmenu = menuItemEl => {
	const isSubmenuOpen = menuItemEl.getAttribute('data-is-submenu-open') === 'true';

	menuItemEl.setAttribute('data-is-submenu-open', !isSubmenuOpen);
	menuEl.setAttribute('data-has-open-submenu', !isSubmenuOpen);
};

const toggleDesktopSubmenu = (menuItemEl, shouldOpen) => {
	const currentlyOpenSubmenu = menuEl.querySelector('[data-is-submenu-open=true]');
	if (currentlyOpenSubmenu) {
		currentlyOpenSubmenu.setAttribute('data-is-submenu-open', false);
	}

	menuItemEl && menuItemEl.setAttribute('data-is-submenu-open', shouldOpen);
};

// Pulls customer variable from theme.liquid
if (customer) {
	let isAccountMenuOpen = false;
	const accountMenuIconEl = document.getElementById('accountIconWrapper');
	const accountMenuDropdownEl = document.getElementById('accountMenuDropdown');
	const accountMenuCloseEl = document.getElementById('accountMenuClose');

	function clickOutside(e) {
		const isClickInside = accountMenuDropdownEl.contains(e.target);
		if (!isClickInside) {
			isAccountMenuOpen = false;
			toggleAccountMenu({ action: 'CLOSE' });
		}
	}

	accountMenuIconEl.addEventListener('mouseenter', e => {
		e.preventDefault();

		toggleAccountMenu({ action: 'OPEN' });
	});

	accountMenuIconEl.addEventListener('pointerdown', e => {
		e.stopPropagation();

		toggleAccountMenu({ action: isAccountMenuOpen === true ? 'CLOSE' : 'OPEN' });
	});

	accountMenuDropdownEl.addEventListener(
		'mouseleave',
		e => {
			e.preventDefault();

			toggleAccountMenu({ action: 'CLOSE' });
		},
		false
	);

	accountMenuCloseEl.addEventListener(
		'click',
		e => {
			e.preventDefault();

			toggleAccountMenu({ action: 'CLOSE' });
		},
		false
	);

	function toggleAccountMenu({ action }) {
		if (action === 'CLOSE') {
			isAccountMenuOpen = false;
			accountMenuDropdownEl.setAttribute('aria-hidden', true);
			accountMenuDropdownEl.style.display = 'none';
			return document.removeEventListener('pointerdown', clickOutside);
		}

		isAccountMenuOpen = true;
		accountMenuDropdownEl.setAttribute('aria-hidden', false);
		accountMenuDropdownEl.style.display = 'flex';
		return document.addEventListener('pointerdown', clickOutside);
	}
}
